<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="编号:"
                      prop="dev_sn">
          <el-input v-model.trim="searchForm.dev_sn"
                    placeholder="编号"></el-input>
        </el-form-item>
        <el-form-item label="房间:"
                      prop="room_name">
          <el-input v-model.trim="searchForm.room_name"
                    placeholder="房间"></el-input>
        </el-form-item>
        <el-form-item label="维修状态:"
                      prop="repair_status">
          <el-select v-model="searchForm.repair_status"
                     placeholder="维修状态">
            <el-option label="待维修"
                       value="0"></el-option>
            <el-option label="已维修"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/repair/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <!-- <el-button type="primary"
                 @click="multipleDelete">批量删除</el-button> -->
      <el-button type="primary"
                 @click="handleExport">导 出</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="80"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'repair_status'">
              <el-tag v-if="scope.row[item.prop] === '0'"
                      type="danger">
                待维修
              </el-tag>
              <el-tag v-else-if="scope.row[item.prop] !== '2'"
                      type="success">
                已维修
              </el-tag>
              <el-tag v-else
                      type="success">
                已撤销
              </el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button v-has="'/repair/edit'"
                       :disabled="scope.row.repair_status !== '0'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/repair/repair'"
                       :disabled="scope.row.repair_status !== '0'"
                       size="mini"
                       type="primary"
                       @click="handleRepair(scope.row)">维修</el-button>
            <!-- <el-button size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-repair v-if="showRepairModal"
                :isShow="showRepairModal"
                :data="repairData"
                @handleClose="closeHolidayModal"></add-repair>
    <Deal v-if="showDealModal"
          :isShow="showDealModal"
          :data="dealData"
          @handleClose="closeDealModal"></Deal>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import utils from '@/common/utils'
import AddRepair from '@/views/device/repair/AddRepair'
import Deal from '@/views/device/repair/Deal'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddRepair, Deal, Pagination },
  data() {
    return {
      searchForm: {
        code: '',
        room: '',
        status: ''
      },
      tableTitle: [
        {
          prop: 'dev_sn',
          name: '设备编号',
          width: '80'
        },
        {
          prop: 'dev_name',
          name: '设备名称',
          width: '80'
        },
        {
          prop: 'dev_type',
          name: '设备类型',
          width: '80'
        },
        {
          prop: 'room_name',
          name: '所在房间',
          width: '100'
        },
        {
          prop: 'area_names',
          name: '所属机构',
          width: '100'
        },
        {
          prop: 'fault_desc',
          name: '故障描述',
          width: '100'
        },
        {
          prop: 'check_up',
          name: '自检情况',
          width: '100'
        },
        {
          prop: 'submitter',
          name: '报修人',
          width: '80'
        },
        {
          prop: 'sub_phone_no',
          name: '报修人电话',
          width: '120'
        },
        {
          prop: 'sub_datetime',
          name: '报修时间',
          width: '120'
        },
        {
          prop: 'repair_status',
          name: '维修状态',
          width: '80'
        },
        {
          prop: 'repair_desc',
          name: '维修描述',
          width: '130'
        },
        {
          prop: 'repairman',
          name: '维修人',
          width: '80'
        },
        {
          prop: 'rep_phone_no',
          name: '维修人电话',
          width: '120'
        },
        {
          prop: 'repair_datetime',
          name: '维修时间',
          width: '120'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加维修相关
      showRepairModal: false,
      repairData: {
        type: 'add'
      },
      // 维修记录相关
      showDealModal: false,
      dealData: {
        id: -1
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      // 维修状态 0-未修 1-已修 2-撤销
      const { perPage, currentPage } = this.pagination
      fetch
        .getRepairList({
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加维修
    handleAdd() {
      this.showRepairModal = true
      this.repairData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delRepair(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择房型后重试')
      }
    },
    // 编辑
    handleEdit(data) {
      this.showRepairModal = true
      this.repairData = {
        type: 'edit',
        data: data
      }
    },
    closeHolidayModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showRepairModal = false
    },
    // 维修
    handleRepair(data) {
      this.showDealModal = true
      this.dealData = {
        id: data.id
      }
    },
    closeDealModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showDealModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRepair(data.id)
        })
        .catch(() => {})
    },
    // 删除方法
    delRepair(ids) {
      fetch.delRepair({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.$message.success('操作成功')
            this.getList()
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 导出
    handleExport() {
      fetch
        .exportRepair(
          {
            ...this.searchForm
          },
          { responseType: 'blob' }
        )
        .then((data) => {
          var blob = new Blob([data.res])
          let date = utils.format(new Date().getTime(), 'yyyy-MM-dd')
          let filename = '报修记录-' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        })
    }
  }
}
</script>

<style></style>
